import { actionCreatorFactory } from 'typescript-fsa';
import { ClientSymbolListMode } from '@cbridge-modules/symbol-client-data-grid';

export namespace ControllerSymbolClientAction {
  const actionCreator = actionCreatorFactory('ControllerSymbolClient');

  export const setMode = actionCreator<ClientSymbolListMode>('SET_MODE');
  export const destroy = actionCreator('DESTROY');
}
